import $ from 'jquery';
import truncate from '../utils/truncate';

const truncateText = () => {
  const texts = $('[data-truncate]');

  if (texts.length > 0) {
    for (const str of texts) {
      const toCharLength = $(str).data('truncate');
      const fullText = $(str).text();
      const andKeepWholeWord = true;

      const truncatedText = truncate(fullText, toCharLength, andKeepWholeWord);

      $(str).text(truncatedText);
    }
  }
}

export default truncateText;
